<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Correciones </legend>
          </div>

          <div v-if="!add_item">
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6">
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <b-table id="tbl_correcciones" responsive hover :items="list_usuarios" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter">
                  <!-- :fields="fields_list" -->
                  <template slot="acciones" slot-scope="row" class="actions">
                    <b-button size="sm" @click="row.toggleDetails" class="edit mr-2">
                      <i class="ti-search"></i>
                    </b-button>
                    <!-- <b-button
                      size="sm"
                      @click.prevent="removeItem(row.index)"
                      class="delete mr-2"
                      :disabled="edit_item != null"
                    >
                      <i class="ti-close"></i>
                    </b-button> -->
                  </template>
                  <template slot="row-details" slot-scope="row">
                    <div class="row p-4">
                      <div class=" col-12">
                        <div class="card ">
                          <div class="card-body">
                            <p class="m-0">
                              <strong> Motivo </strong>: {{row.item.motivo}}
                            </p>
                            <p class="m-0">
                              <strong> Cambios revisados por </strong>: {{row.item.usuario.Nombre+' '+row.item.usuario.Paterno+' '+row.item.usuario.Materno}}
                            </p>
                            <p class="m-0">
                              <strong> Cambio </strong>: {{getStatus(row.item.status)}}
                            </p>
                            <p class="m-0">
                               <strong> Observaciones </strong>:{{(row.item.observaciones)}}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">Datos originales</h5>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item" v-for="(value, key) in row.item.origen" :key="key"><strong>{{ key.replace("_", " ") }}</strong> : {{returnValueKey(value,key)}}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">Datos actualizados</h5>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item" v-for="(value, key) in row.item.cambio" :key="key"><strong>{{  key.replace("_", " ") }}</strong> : {{returnValueKey(value,key)}}</li>
                            </ul>
                          </div>
                        </div>
                      </div>                      

                    </div>                      
                   
                  </template>
                  <template slot="empty">
                    <h5>No existen registros</h5>
                  </template>
                  <template slot="tipo_id" slot-scope="row">
                    {{getTipoUsuarios(row.item.tipo_id)}}</template>
                  <template slot="encargo.ente_publico_id" slot-scope="row">
                    {{getDependencias(row.item.encargo.ente_publico_id)}}</template>
                  <template slot="usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido" slot-scope="row">
                    {{row.item.usuarios.nombres}} {{row.item.usuarios.primer_apellido}} {{row.item.usuarios.segundo_apellido}}</template>
                </b-table>
              </div>
              <div class="col-mb-12">
                <b-col md="6" class="my-1">
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_correcciones"></b-pagination>
                </b-col>
              </div>
              <div class="col-mb-12 col-12">
                <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import moment from 'moment'
  import {
    Select,
    Option,
    DatePicker
  } from "element-ui";

  import {
    mapFields
  } from "vee-validate";

  import Domicilio from "../Domicilio.vue";

  Vue.use(Select);
  Vue.use(Option);
  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    props: ["data"],
    data() {
      return {
        movimiento:{},
        options: [{
            id: 1,
            label: "foo"
          },
          {
            id: 3,
            label: "bar"
          },
          {
            id: 2,
            label: "baz"
          }
        ],
        currentPage: 1,
        perPage: 50,
        validarp:false,
        rows:0,
        rol: "",
        filter: null,
        id: 1,
        add_item: false,
        edit_item: null,
        tipos: null,
        n_domicilio: null,
        dependencias: null,
        usuarios: null,
        item_usuarios: {},
        list_usuarios: [],
        item_usuariosValidations: {
          rfc: {
            required: true
          },
          curp: {
            required: true
          },
          nombres: {
            required: true
          },
          primer_apellido: {
            required: true
          },
          segundo_apellido: {
            required: true
          },
          ente_publico_id: {
            required: true
          },
          direccion_cargo: {
            required: true
          },
          nivel: {
            required: true
          },
          area_adscripcion: {
            required: true
          },
          honorarios: {
            required: true
          },
          AG172: {
            required: true
          },
          fecha_inicio: {
            required: true
          },
          tipo_baja: {
            required: true
          },
          termina: {
            required: true
          },
          inicia: {
            required: true
          },
          tipo_lic: {
            required: true
          },
          observaciones: {
            required: true
          },
          empleo_cargo_comision: {
            required: true
          },
          observaciones:{
            required: true
          }
        },
        fields_list: [{
            key: "acciones",
            label: "Acciones",
            thClass: "td-small",
            tdClass: "text-center td-small"
          },
          {
            key: "updated_at",
            label: "Fecha",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: value => {
              if(value)
                return moment(String(value)).format('DD/MM/YYYY')
              else
                return ''
            }
          },
          {
            key: "usuarios.rfc",
            label: "RFC",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: "emptyFields"
          },
          {
            key: "usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",
            label: "Nombre",
            tdClass: "text-left",
            formatter: "emptyFields"
          }
        ],
        selects: {
          simple: "",
          movimientos: [{
              value: "1",
              label: "Desactivar servidor"
            },
            {
              value: "2",
              label: "Crear baja "
            },
            {
              value: "3",
              label: "Crear licencia"
            },
            {
              value: "4",
              label: "Crear promoción"
            },
            {
              value: "5",
              label: "Realizar corrección"
            },
            {
              value: "6",
              label: "Cambiar contraseña"
            }
          ]
        }
      };
    },
    computed: {
      ...mapFields([
        "rfc",
        "curp",
        "nombres",
        "primer_apellido",
        "segundo_apellido",
        "ente_publico_id",
        "direccion_cargo",
        "nivel",
        "area_adscripcion",
        "honorarios",
        "AG172",
        "Password",
        "Confirmar",
        "fecha_inicio",
        "tipo_baja",
        "termina",
        "inicia",
        "tipo_lic",
        "observaciones",
        "empleo_cargo_comision"
      ]),
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_usuarios.length);
        this.rows = this.list_usuarios.length;

        return this.list_usuarios.length;
      },
      fullName: {
        get() {
          return `${this.item_usuarios.nombres} ${
          this.item_usuarios.primer_apellido
        } ${this.item_usuarios.segundo_apellido}`;
        },
        set(newValue) {
          const m = newValue.match(/(\S*)\s+(.*)/);

          this.nombres = m[1];
          this.primer_apellido = m[2];
          this.segundo_apellido = m[3];
        }
      }
    },
    methods: {
      formato(fecha){
        return moment(String(value)).format('DD/MM/YYYY')
      },
      returnValueKey(v, k) {
        var resp = "";
        if (k == "dependencia") {
          resp = this.getDependencias(v);
        } else if (k == "honorarios") {
          resp = v == 0 ? "NO" : "SI";
        } else {
          resp = v;
        }
        return resp;
      },
      initItem() {
        this.item_usuarios = {
          acciones: "",
          nombres: "",
          Paterno: "",
          Materno: "",
          User: "",
          Password: ""
        };
         this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            //this.dependencias.unshift({ id: 0, valor: "Todos" });
          },
          error => {
            this.Err(error);
          }
        );
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getDependencias(index) {
        var resp = " ";
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getUsuario(index) {
        var resp = " ";
        if (this.usuarios) {
          this.usuarios.forEach(function (item) {
            if (item.id == index) {
              resp = item.Nombre + " " + item.Paterno + " " + item.Materno;
              return resp;
            }
          });
        }
        return resp;
      },
      getStatus(status) {
        if (status === 1) {
            return "Aprobado";
        }
        else{
            return "Rechazado"
        }
      }
    },
    created() {
      this.initItem();
      if(this.getKey('permisos').includes(19)){
            this.validarp = true;
      }
      this.$http.get("historial").then(
        response => {
          this.list_usuarios = response.data.usuarios;
        //  console.log(this.list_usuarios);
        },
        error => {
          this.Err(error);
        }
      );
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/HCorrecciones.vue